import { fetchRemoteConnect, getMyProfile, registerRemoteConnect } from '@/api';
import appIcon from '@/assets/icons/app.svg';
import babyshark from '@/assets/images/default/babyshark.png';
import { ClientAuth } from '@/classes';
import { SECOND_MS } from '@/constants';
import { useRouter } from '@/hooks/useRouter';
import { QRCodeSVG } from 'qrcode.react';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

type RemoteConnectPayload = {
  remoteUUID: string;
  url: string;
  expiredAt: number;
};

export const LoginPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const [payload, setPayload] = useState<RemoteConnectPayload>();
  const [leftDuration, setLeftDuration] = useState<number>(300);

  const load = useCallback(async () => {
    try {
      const payload = await registerRemoteConnect();

      // if (process.env.NODE_ENV === 'development') {
      console.info('Registered remote connection payload', payload);
      // }

      setPayload(payload);
    } catch (e) {
      console.error(e);
    }
  }, []);

  const url = useMemo(() => {
    if (payload) {
      return payload.url;
    }
  }, [payload]);

  const hash = useMemo(() => {
    if (payload) {
      return payload.remoteUUID.substring(0, 8);
    }
  }, [payload]);

  useEffect(() => {
    if (payload) {
      const refreshInterval = setInterval(async () => {
        try {
          const connected = await fetchRemoteConnect(payload.remoteUUID);

          if (connected) {
            const isLoggedIn = await ClientAuth.refresh();

            if (isLoggedIn) {
              ClientAuth.user = await getMyProfile();
              clearInterval(refreshInterval);
              router.push('/home', { replace: true });
            }
          } else if (payload.expiredAt - Date.now() <= 0) {
            load();
          }
        } catch (e) {
          console.error('로그인 확인 오류', e);
        }
      }, 5 * SECOND_MS);

      const leftDurationInterval = setInterval(() => {
        setLeftDuration(Math.max(Math.round((payload.expiredAt - Date.now()) / SECOND_MS), 0));
      }, SECOND_MS);

      return () => {
        clearInterval(refreshInterval);
        clearInterval(leftDurationInterval);
      };
    }
  }, [load, router, payload]);

  useEffect(() => {
    if (ClientAuth.user) {
      router.push('/home', { replace: true });
    } else {
      load();
    }
  }, [load, router]);

  return (
    <div style={{ width: '1920px', height: '1080px' }}>
      <div
        className="bg-[#FFFDF1] text-black pl-[100px] pt-[90px] text-[30px]"
        style={{ width: '100%', height: '346px', position: 'relative' }}
      >
        <div className="flex flex-row items-center">
          <img src={appIcon} className="w-fit h-fit" />
          <h1 className="text-[54px] font-bold ml-6">{t('page_sign_in_header')}</h1>
        </div>
        <p className="mt-[29px] whitespace-pre-line">{t('page_sign_in')}</p>
      </div>
      <div className="bg-[#0F2648] text-white text-[36px] pl-[284px] flex w-full h-[calc(100%-346px)]">
        {payload && (
          <>
            <div className="flex h-full">
              <div className="flex col flex-col items-center justify-center w-full">
                <div>{t('page_sign_in_code')}</div>
                <div className="text-[80px] font-bold">{hash}</div>
                <div>{t('page_sign_in_time')}</div>
                <div className="text-[80px] font-bold">{leftDuration}</div>
              </div>
            </div>
            <div className="relative ml-[316px] flex h-full">
              <div className="relative m-auto">
                <img src={babyshark} className="absolute right-[-150px] bottom-8 z-0" />
                <div
                  style={{
                    margin: 'auto',
                    padding: '20px',
                    borderRadius: '10px',
                    border: '8px solid #FFD100',
                    width: '459px',
                    height: '459px',
                    display: 'inline-block',
                    position: 'relative',
                    backgroundColor: '#fff',
                  }}
                >
                  {url && <QRCodeSVG style={{ zIndex: 1 }} value={url!} width="100%" height="100%" />}
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
  );
};
